import { createAppSettingsContext } from "@britishcouncil/react-common";

export interface AppSettings {
  sentry: { environment: string; release: string };
}

export const DEFAULT_APP_SETTINGS: AppSettings = {} as AppSettings;
export const { AppSettingsContext, useAppSettings } =
  createAppSettingsContext<AppSettings>();
